<template>
  <div class="header-seu-plano dados-beneficiario-tab">
    <div class="container alianca-content">
      <div class="row dados-beneficiario-tab-centered">
        <b-col class="dados-beneficiario-tab-item" :class="{ 'bg-tab-active': active == 1 }">
          Dados do beneficiário 
          <img v-if="active == 2 || active == 3" src="../assets/statusok.svg" alt="Dados do beneficiário">
          <img v-else src="../assets/edit.svg" alt="Dados do beneficiário">
        </b-col>
        <b-col class="dados-beneficiario-tab-item" :class="{ 'bg-tab-active': active == 2 }">
          Declaração de saúde
          <img v-if="active == 3" src="../assets/statusok.svg" alt="Declaração de saúde">
          <img v-else src="../assets/edit.svg" alt="Declaração de saúde">
        </b-col>
        <b-col class="dados-beneficiario-tab-item" :class="{ 'bg-tab-active': active == 3 }">Dados de cobrança <img src="../assets/edit.svg" alt="Dados de cobrança"></b-col>
      </div>
    </div>
  </div> 
</template>

<script>
export default {
  name: "Dados-proposta",
  props: [ 'active' ],
  data() {
    return {};
  },
  created() {
  },
};
</script>
